module.exports = __webpack_public_path__ + "img/dashboard-active.935696e4.svg";